import moment from "moment";

export function getHoursFormatted(start: string, end: string): string {
    const format: string = "HH:mm";
    return `${ moment(start).format(format) } - ${ moment(end).format(format) }`;
}
